const RESET_UID_KEYS = ["uid", "uidb64", "user_id", "userId"];
const RESET_TOKEN_KEYS = ["token", "reset_token", "resetToken"];

const getFirstParam = (params, keys) => {
  for (const key of keys) {
    const value = params.get(key);
    if (value) return value;
  }

  return null;
};

const collectSearchStrings = (source) => {
  const searches = [];

  if (typeof window !== "undefined") {
    searches.push(window.location.search);

    if (window.location.hash?.includes("?")) {
      searches.push(window.location.hash.slice(window.location.hash.indexOf("?")));
    }
  }

  if (typeof source === "string") {
    const queryIndex = source.indexOf("?");
    if (queryIndex >= 0) searches.push(source.slice(queryIndex));
  } else if (source) {
    searches.push(source.search);

    if (source.hash?.includes("?")) {
      searches.push(source.hash.slice(source.hash.indexOf("?")));
    }
  }

  return searches.filter(Boolean);
};

export const getResetPasswordParams = (source) => {
  for (const search of collectSearchStrings(source)) {
    const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
    const uid = getFirstParam(params, RESET_UID_KEYS);
    const token = getFirstParam(params, RESET_TOKEN_KEYS);

    if (uid || token) {
      return { uid, token };
    }
  }

  return { uid: null, token: null };
};
